"use client";

import React from "react";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";

import {
  saasDashboardHeroData,
  saasStatsData,
  saasSolutionsAndProcessData,
  saasPortfolioData,
  saasTechnologiesData,
  saasAboutData,
  saasDashboardFaqs,
} from "src/utils/mock/saasDashboardData";

import { caseStudies } from "src/utils/mock/caseStudies";
import CommonContactSection from "src/components/Common/CommonContactSection/index.jsx";

export default function SaaSDashboardDesignComponent({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const activeProjects = liveProjects.filter((project) => {
    const isWebDesign = project.platforms?.toLowerCase().includes("web");
    return project.projectStatus?.toLowerCase() === "active" && isWebDesign;
  });

  const filteredData = {
    ...saasPortfolioData,
    projects: {
      liveProjects: activeProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={saasDashboardHeroData} />
      <TechStats stats={saasStatsData} />
      <WhyChooseUs data={saasSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={saasTechnologiesData} techIcons={techIcons} />
          <TechsSection sections={saasAboutData} mainTitle="About SaaS Dashboard Design" />
        </div>
      </section>

      <FAQSection faqs={saasDashboardFaqs} />
      <CommonContactSection />
    </div>
  );
}
